<template>
  <div>
    <div class="container">
      <article class="message is-info">
        <div class="message-header large">
          <p>Update 28/02/2019 11:59AM</p>
          <!-- <button class="delete" aria-label="delete"></button> -->
        </div>
        <div class="message-body medium">
          <ul>
            <li>Please beware, this is work in progress!</li>
          </ul>
        </div>
      </article>
    </div>
    <article class="is-parent box">
    <h1 class="title has-text-centered">Season Totals</h1>
    <season-totals-menu name="raw-data"></season-totals-menu>
     <section id="gameFilters">
      <div class="is-parent  is-vertical">
            <article class="is-child box">
        <h2 class="subtitle"><b>Filters</b></h2>
          <div class="columns">
            <div class="column is-3">
              <label class="label">Season</label>
              <div class="control">
                <div class="select">
                  <select v-model="YearSelected" @change="fetchSeasonStats">
                    <option value=2022>2022-2023</option>
                    <option value=2019>2019-2020</option>
                    <option value=2018>2018-2019</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column is-3">
              <label class="label">Competition</label>
              <div class="control">
                <div class="select">
                  <select v-model="CompetitionSelected"  @change="fetchSeasonStats">
                    <option v-for="option in CompetitionOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
              <div class="column is-4">
                <label class="label">Opponent</label>
                <div class="control">
                  <div class="select">
                    <select  v-model="OpponentSelected"  @change="fetchSeasonStats">
                      <option v-for="option in OpponentOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                    </select>
                  </div>
                </div>
            </div>
            <div class="column is-5">
              <label class="label">Venue</label>
              <div class="control">
                <div class="select">
                  <select v-model="VenueSelected"  @change="fetchSeasonStats">
                    <option v-for="option in VenueOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column is-4">
                <label class="label">Limit</label>
                <div class="control">
                  <div class="select">
                    <select v-model="LimitSelected" @change="fetchSeasonStats">
                      <option v-for="option in LimitOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                    </select>
                  </div>
                </div>
            </div>
          </div>
        </article>
      </div>
    </section>
    </article>
   
    <section id="rawdata">
    <div class="tile is-parent is-12 is-vertical">
    <article class="tile is-child box">
      <div class="container is-child" style="margin-top:5px;">
        <h1 class="title has-text-centered">All Data</h1>
        <div class="rol-wrapper">
          <div class="rol-scroller">
             <table class="table rol-table" style="">
                <thead>
                  <th class="rol-sticky-col">Player</th>
                  <th class="rol-sticky-col-gp">GP</th>
                  <th class="shots-col" @click="sortDataBy('shots')"><a class="shots-col">SHOTS</a></th>
                  <th class="shots-col" @click="sortDataBy('shots_on_net')"><a class="shots-col">SOT</a></th>
                  <th class="shots-col" @click="sortDataBy('shots_missed_net')"><a class="shots-col">MISSED</a></th>
                  <th class="shots-col" @click="sortDataBy('shots_blocked')"><a class="shots-col">BLOCKED</a></th>
                  <th class="shots-col" @click="sortDataBy('shots_percentage')"><a class="shots-col">SH%</a></th>
                  <th class="shots-diff-col" @click="sortDataBy('shots_for')"><a class="shots-diff-col">CF</a></th>
                  <th class="shots-diff-col" @click="sortDataBy('shots_for')"><a class="shots-diff-col">CA</a></th>
                  <th class="shots-diff-col" @click="sortDataBy('shots_for')"><a class="shots-diff-col">CDIFF</a></th>
                  <th class="shots-diff-col" @click="sortDataBy('shots_for')"><a class="shots-diff-col">CF%</a></th>
                  <th class="shots-diff-col" @click="sortDataBy('shots_for')"><a class="shots-diff-col">CREL</a></th>
                  <th class="toi-col" @click="sortDataBy('toi_total')"><a class="toi-col">TOI</a></th>
                  <th class="toi-col" @click="sortDataBy('toi_game')"><a class="toi-col">TOI/G</a></th>
                  <th class="toi-col" @click="sortDataBy('toi_shifts')"><a class="toi-col">SHIFTS</a></th>
                  <th class="toi-col" @click="sortDataBy('toi_avg_shift')"><a class="toi-col">SH/G</a></th>
                  <th class="toi-col">TOI/SHIFT</th>
                  <th class="faceoff-col" @click="sortDataBy('fo_taken')"><a class="faceoff-col">FO</a></th>
                  <th class="faceoff-col" @click="sortDataBy('fo_win')"><a class="faceoff-col">FO WIN</a></th>
                  <th class="faceoff-col" @click="sortDataBy('fo_loss')"><a class="faceoff-col">FO LOSS</a></th>
                  <th class="faceoff-col" @click="sortDataBy('')"><a class="faceoff-col">FO +/-</a></th>
                  <th class="faceoff-col" @click="sortDataBy('')"><a class="faceoff-col">FOW/G</a></th>
                  <th class="faceoff-col" @click="sortDataBy('fo_win_percentage')"><a class="faceoff-col">FOW%</a></th>
                  <th class="hits-col" @click="sortDataBy('hits')"><a class="hits-col">HITS</a></th>
                  <th class="hits-col">HITS/G</th>
                  <th class="turnovers-col" @click="sortDataBy('turnovers')"><a class="turnovers-col">TURNOVERS</a></th>
                  <th class="turnovers-col">TURNOVERS/G</th>
                  <th class="pim-col" @click="sortDataBy('pim_drawn')"><a class="pim-col">PIM +</a></th>
                  <th class="pim-col" @click="sortDataBy('pim_taken')"><a class="pim-col"> PIM -</a></th>
                  <th class="pim-col">PIM +/-</th>
                  <th class="pim-col">PIM/G</th>
                </thead>
                <tbody>
                <tr v-for="player in PlayerTotals" v-bind:key="player.player">
                  <th class="rol-sticky-col">{{player.player}}</th>
                  <td class="rol-sticky-col-gp">{{player.gp}}</td>
                  <td class="shots-col">{{player.shots}}</td>
                  <td class="shots-col">{{player.shots_on_net}}</td>
                  <td class="shots-col">{{player.shots_missed_net}}</td>
                  <td class="shots-col">{{player.shots_blocked}}</td>
                  <td class="shots-col">{{player.shots_percentage}}</td>
                  <td class="shots-diff-col">{{player.shots_for}}</td>
                  <td class="shots-diff-col">{{player.shots_against}}</td>
                  <td class="shots-diff-col">{{player.shots_for - player.shots_against}}</td>
                  <td class="shots-diff-col">{{player.shots_diff_percentage}}</td>
                  <td class="shots-diff-col">{{player.shots_relative}}</td>
                  <td class="toi-col">{{player.toi_total}}</td>
                  <td class="toi-col">{{player.toi_game}}</td>
                  <td class="toi-col">{{player.toi_shifts}}</td>
                  <td class="toi-col">{{player.toi_shifts / player.gp | fixedDP}}</td>
                  <td class="toi-col">{{player.toi_avg_shift}}</td>
                  <td class="faceoff-col">{{player.fo_taken}}</td>
                  <td class="faceoff-col">{{player.fo_win}}</td>
                  <td class="faceoff-col">{{player.fo_loss}}</td>
                  <td class="faceoff-col">{{player.fo_win - player.fo_loss}}</td>
                  <td class="faceoff-col">{{player.fo_win / player.gp | fixedDP}}</td>
                  <td class="faceoff-col">{{player.fo_win_percentage}}</td>
                  <td class="hits-col">{{player.hits}}</td>
                  <td class="hits-col">{{player.hits / player.gp | fixedDP}}</td>
                  <td class="turnovers-col">{{player.turnovers}}</td>
                  <td class="turnovers-col">{{player.turnovers / player.gp | fixedDP}}</td>
                  <td class="pim-col">{{player.pim_drawn}}</td>
                  <td class="pim-col">{{player.pim_taken}}</td>
                  <td class="pim-col">{{player.pim_drawn - player.pim_taken}}</td>
                  <td class="pim-col">{{player.pim_taken / player.gp | fixedDP}}</td>
                </tr>
                </tbody>
            </table>
          </div>
        </div>
      </div>
    </article>
    </div>
    </section>
    <section name="GoalsByGame">
    <div class="tile is-parent is-12 is-vertical">
    <article class="tile is-child box">
      <div class="container is-child" style="margin-top:5px;">
        <h1 class="title has-text-centered">Goals By Game</h1>
        <div class="rol-wrapper">
          <div class="rol-scroller">
             <table class="table rol-table-sub">
                <thead>
                  <th class="rol-sticky-col-game">Game</th>
                  <th>Goal Data</th>
                </thead>
                <tbody>
                <tr v-for="game in GoalsByGame" v-bind:key="game.match_date">
                  <th class="rol-sticky-col-game">{{game.match_date}}</th>
                  <td v-for="goal in game.goals" v-bind:key="goal.goal_id">
                    <table v-bind:class="[{'is-plus': goal.team_id == 1}, {'is-minus': goal.team_id != 1}]">
                      <tr><td><b>GS: {{goal.goal_scorer}}</b> A1: {{goal.first_assist}}  A2:{{goal.second_assist}} <b>{{goal.situation_id}}</b></td></tr>
                      <tr>
                        <td >{{goal.on_ice_1}}
                        {{goal.on_ice_2}}
                        {{goal.on_ice_3}}
                        {{goal.on_ice_4}}
                        {{goal.on_ice_5}}
                        {{goal.on_ice_6}} 
                        </td><td>P: {{goal.period}}</td>
                      </tr>
                    </table>
                  </td>
                </tr>
                </tbody>
             </table>
          </div>
        </div>
      </div>
    </article>
    </div>
    </section>
  </div>
</template>
<script>
import DataTable from '../data-table'
import SubTable from '../sub-table'
import SeasonTotals from '../season-totals-menu'
import Chart from 'vue-bulma-chartjs'
import _ from 'lodash'
export default {
  components: {
    'data-table': DataTable,
    'sub-table': SubTable,
    'season-totals-menu': SeasonTotals,
    Chart
  },
  filters: {
    fixedDP: function (value) {
      return value.toFixed(2)
    }
  },
  data () {
    return {
      GameFilter: [],
      CompetitionOptions: [],
      VenueOptions: [],
      OpponentOptions: [],
      SituationOptions: [],
      PeriodOptions: [],
      LimitOptions: [],
      YearSelected: 2022,
      CompetitionSelected: 'EIHL_Challenge_Cup',
      VenueSelected: 0,
      OpponentSelected: 0,
      PeriodSelected: 0,
      SituationSelected: 0,
      LimitSelected: 0,
      FilterSelected: 'total_points',
      PlayerTotals: [],
      sortAsc: false,
      GoalsByGame: []
    }
  },
  computed: {
  },
  methods: {
    sortDataBy (value) {
      this.sortAsc = !this.sortAsc
      if (this.sortAsc) {
        this.PlayerTotals = _.orderBy(this.PlayerTotals, value, ['asc'])
      } else {
        this.PlayerTotals = _.orderBy(this.PlayerTotals, value, ['desc'])
      }
    },
    fetchSeasonStats () {
      let postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': 0,
        'limit': this.LimitSelected
      }
      console.log('Filter: ' + JSON.stringify(postData))
      this.$http
        .post('https://devilsapi.roblutken.com/api/app/season-stats/season-player-totals/', postData, {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
        })
        .then(
          response => {
            console.log(response.data)
            this.PlayerTotals = response.data.player_totals
          },
          response => {}
        )
      this.$http
        .post('https://devilsapi.roblutken.com/api/app/season-stats/season-goals-by-game/', postData, {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
        })
        .then(
          response => {
            console.log(response.data)
            this.GoalsByGame = response.data.goals_by_game
          },
          response => {}
        )
    },
    fetchFilterOptions () {
      this.$http.get('https://devilsapi.roblutken.com/api/app/season-stats/filters/', {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(
          response => {
            // console.log(response.data)
            let venue = response.data.venue
            this.VenueOptions.push({text: 'All', value: 0})
            for (var i = 0; i < venue.length; i++) {
              this.VenueOptions.push({text: venue[i].location, value: venue[i].location})
            }
            let opponent = response.data.teams
            this.OpponentOptions.push({text: 'All', value: 0})
            for (var j = 0; j < opponent.length; j++) {
              if (opponent[j].id !== '1') {
                this.OpponentOptions.push({text: opponent[j].name, value: opponent[j].id})
              }
            }
            let situations = response.data.situations
            this.SituationOptions.push({text: 'All', value: 0})
            this.SituationOptions.push({text: '--Primary Situations--', value: -6})
            this.SituationOptions.push({text: 'Even Handed', value: -1})
            this.SituationOptions.push({text: 'Power Play', value: -2})
            this.SituationOptions.push({text: 'Short Handed', value: -3})
            this.SituationOptions.push({text: 'Empty Net', value: -4})
            this.SituationOptions.push({text: '--Secondary Situations--', value: -5})
            for (var s = 0; s < situations.length; s++) {
              this.SituationOptions.push({text: situations[s].secondary_situation, value: situations[s].id})
            }
            this.CompetitionOptions.push({text: 'All', value: 0})
            this.CompetitionOptions.push({text: 'EIHL & Challenge Cup', value: 'EIHL_Challenge_Cup'})
            this.CompetitionOptions.push({text: 'EIHL', value: 'EIHL'})
            this.CompetitionOptions.push({text: 'Challenge Cup', value: 'Challenge-Cup'})
            this.CompetitionOptions.push({text: 'Pre-Season', value: 'Pre-Season'})
            this.CompetitionOptions.push({text: 'Playoffs', value: 'Playoffs'})
            this.CompetitionOptions.push({text: 'CHL', value: 'CHL'})

            this.PeriodOptions.push({text: 'All', value: 0})
            this.PeriodOptions.push({text: 'Period 1', value: 1})
            this.PeriodOptions.push({text: 'Period 2', value: 2})
            this.PeriodOptions.push({text: 'Period 3', value: 3})
            this.PeriodOptions.push({text: 'Period OT', value: 4})
            this.PeriodOptions.push({text: 'Period Shootout', value: 5})

            this.LimitOptions.push({text: 'All', value: 0})
            this.LimitOptions.push({text: '5 Games', value: 5})
            this.LimitOptions.push({text: '10 Games', value: 10})
            this.LimitOptions.push({text: '20 Games', value: 20})
          }
        )
    }
  },
  created () {
    this.fetchSeasonStats()
    this.fetchFilterOptions()
  }
}
</script>
<style>
#fixed-div {
    position: fixed;
    top: 1em;
    right: 1em;
}
.rol-table {
    border: none;
    border-right: solid 1px #DDEFEF;
    border-collapse: separate;
    border-spacing: 0;
    
}
.is-plus{
  background-color:#04A777;
  color:white;
}
.is-minus{
  background-color:#780116;
}
.rol-table thead th {
    background-color: #DDEFEF;
    border: none;
    color: #336B6B;
    padding: 10px;
    text-align: left;
    
    white-space: nowrap;
}
.rol-table tbody td {
    border-bottom: solid 1px #DDEFEF;
    color: #333;
    padding: 10px;
    text-shadow: .3px .3px .3px rgb(240, 240, 240);
    white-space: nowrap;
}
.rol-table-sub thead th {
    background-color: #DDEFEF;
    border: none;
    color: #336B6B;
    padding: 10px;
    text-align: left;
    
    white-space: nowrap;
}
.rol-table-sub tbody td {
    color: white;
    padding: 5px;
    white-space: nowrap;
}
.rol-table-sub tbody td:hover {
    color: black;
    padding: 5px;
    white-space: nowrap;
}
.rol-wrapper {
    position: relative;
    width:100%;
}
.rol-scroller {
    margin-left: 161px;
    overflow-x: scroll;
    overflow-y: visible;
    padding-bottom: 5px;
    width: 100%;
}
.rol-table .rol-sticky-col {
    border-left: solid 1px #DDEFEF;
    border-right: solid 1px #DDEFEF;
    left: 0;
    position: absolute;
    top: auto;
    width: 120px;
}
.rol-table .rol-sticky-col-gp {
    border-left: solid 1px #DDEFEF;
    border-right: solid 1px #DDEFEF;
    left: 120px;
    position: absolute;
    top: auto;
    width: 40px;
}
.rol-sticky-col-game {
    border-left: solid 1px #DDEFEF;
    border-right: solid 1px #DDEFEF;
    left: 0px;
    position: absolute;
    top: auto;
    width: 170px;
}
.rol-table .goal-col{
  background-color:#780116;
  color:whitesmoke;
}
.rol-table .shots-col{
  background-color:#00A6A6;
  color:whitesmoke;

}
.rol-table .shots-diff-col{
  background-color:#005B5B;
  color:whitesmoke;

}
.rol-table .toi-col{
  background-color:#EFCA08;
  color:black;

}
.rol-table .plus-minus-col{
  background-color: #2B4141;
  color:whitesmoke;

}
.rol-table .hits-col{
  background-color:#9CADCE; 
  color:whitesmoke;
}
.rol-table .faceoff-col{
  background-color:#04A777; 
  color:whitesmoke;
}
.rol-table .turnovers-col{
  background-color: #A599B5;
  color:whitesmoke;
}
.rol-table .pim-col{
  background-color: #6D8EA0;
  color:whitesmoke;
}
.rol-table .blank-col{
  background-color: #DDEFEF;
  font-weight: bold;
  border-bottom: solid 1px black;

}
</style>



// WEBPACK FOOTER //
// raw-data.vue?31060d4a